import styles from './menu.module.css'
import Tab from "../../components/menuComponents/tab/tab";
import Card from "../../components/menuComponents/card-item/card";
import {useEffect, useState} from "react";
import {UseMenu} from "../../context/menuItemsContext";

const Menu = (props) =>
{
	const [{getItem}] = UseMenu()
	const [getMenu, setMenu] = useState()
	useEffect(() =>
	{
		setMenu(getItem)
	}, [getItem])

	const [getSelected, setSelected] = useState('All');
	const onSelectedChange = (value) =>
	{
		setSelected(value)
	}

	return (
		<>
			<Tab changeSelection={onSelectedChange}></Tab>
			<div className={styles.center}>
				<div className={styles.menuContainer}>
					{/*{getMenu ? getMenu.map((item, index) => (<Card key={index} {...item}/>)) : ''}*/}

					{getMenu ? getMenu.map((item, index) => {
						if (getSelected === 'All')
						{
							return <Card key={index} {...item}/>
						}
						else if (getSelected === item.type) {
							return <Card key={index} {...item}/>
						}
						else return ''
					}) : ''}
				</div>
			</div>
		</>
	)
}

export default Menu